var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contact-form',{attrs:{"title":_vm.$prismic.asText(_vm.slice.primary.h2),"description":_vm.slice.primary.p,"background-color":_vm.backgroundColor}})}
var staticRenderFns = []

export { render, staticRenderFns }